import { RootState } from 'typesafe-actions'

import { CurrentUser } from 'typings/currentUser'

export const getCurrentUser = (state: RootState): CurrentUser | undefined => state.user

export const getCurrentOrg = (state: RootState): any | undefined => state.org
